<template>
	<section class="hardware-status">
		<div class="hardware-status-content" v-for="(hardWare, index) in hardWareData" :key="hardWare.name" :span="4" >
			<el-card :body-style="{ padding: '0px' }" shadow="never" >
		      	<div style="padding: 15px;">
			        <span class="device">{{hardWare.name}}</span>
			        <span 
						v-if="hardWare.status" 
						class="status-success">
						<span class="status-icon"></span>
						<span class="status-text">{{ $t('detail.text.normal') }}</span>
						
					</span>
					<el-tooltip v-if="!hardWare.status" class="item status-error" effect="dark" :content="$t('detail.speechCraft.clickToCommit')" placement="top">
						<span >
							<span class="status-icon"></span>
							<a class="status-text" :href="Config.WORK_URL" target="_blank">{{ $t('detail.text.abnormal') }}</a>
						</span>
					</el-tooltip>
	      		</div>
	    	</el-card>
		</div>
	</section>
</template>
<script>
import { deepCopy } from '@/common/tool'
export default {
	props: {
		hardWareData: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
	
		};
	},
	computed: {

	},
	watch: {
		dialogVisible(newVal) {

		}
	},
	methods: {
	}
};
</script>

<style lang="scss">
	@import 'style';
</style>


// WEBPACK FOOTER //
// src/components/common/hardwareStatus/HardwareStatus.vue